module.exports = __webpack_public_path__ + "media/images/athletes/885-5990901baf3a8ea40c70148d4c032aea.png";